import User from './models/User'
import ApiKey from './models/ApiKey'
import { services } from '@billow/js-helpers'
import { signup, authenticate, loadUser as loadAuthUser, loadApiKeys } from '@/api/auth'
import { get } from '../api/request'

let userModel = new User()
let apiKeyModel = new ApiKey()

export default {

  namespaced: true,

  state: {
    user: userModel,
    apiKey: apiKeyModel
  },

  mutations: {
    ...userModel.commonMutations(),
    ...userModel.authMutations(),
    ...apiKeyModel.mutations()
  },

  actions: {
    createAccount: ({ state, commit }) => new Promise((resolve, reject) => signup(state.user, async ({ data }) => {
      commit('setUser', data.user)
      await services.auth.setToken(data.token)
      resolve(data.user)
    }, reject)),
    authenticate: ({ state, dispatch }) => new Promise((resolve, reject) => {
      get('/sanctum/csrf-cookie', () => {
        authenticate({
          email: state.user.email,
          password: state.user.password
        }, async ({ data }) => {
          return dispatch('loadUser').then(() => {
            resolve(data.user)
          }).catch(reject)
        }, reject)
      }, error => reject)
    }),
    loadUser: ({ commit }) => new Promise((resolve, reject) => loadAuthUser(({ data }) => {
      commit('setUser', data)
      resolve(data.user)
    }, reject)),
    loadApiKeys: ({ commit }) => new Promise((resolve, reject) => loadApiKeys(({ data }) => {
      commit('setApiKey', data)
      resolve(data.user)
    }, reject)),
  },

  getters: {
    user: state => state.user
  }

}